import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';
import { CompetitionService } from '../../service/CompetitionService';
// import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import { classNames } from 'primereact/utils';
import { InputTextarea } from 'primereact/inputtextarea';

const CompetitionTrainingReqEditDialog = (props) => {
    const [competition, setCompetition] = useState(null);

    const toast = useRef(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    useEffect(() => {
        setCompetition({ ...props?.value, training: props?.value?.training || '' });
    }, [props.value]);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: competition,
        validate: (data) => {
            let errors = {};

            // if(data.trainingRequired && (!data.training || data.training.trim() === '')) {
            //     errors.training = translatedMessage('form.error.competition.training.required');
            // }

            return errors;
        },
        onSubmit: (data) => {
            // console.log(data);
            saveCompetition(data);
        }
    });

    const hideDialog = () => {
        if (typeof props.visibleSetter === 'function') {
            props.visibleSetter(false);
        }
        formik.resetForm();
    };

    const saveCompetition = (data) => {
        competitionService.saveCompetitionJob(data)
            .then((savedTest) => {
                if (typeof props.afterSave === 'function') {
                    props.afterSave(savedTest, true);
                }
                hideDialog();
                formik.resetForm();
            })
            .catch((error) => {
                if (typeof props.afterSave === 'function') {
                    props.afterSave(null, false, error);
                }
            });
    };

    const dialogFooter = (
        <>
            <Button label={translatedMessage('generic.cancel')} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label={translatedMessage('generic.save')} icon="pi pi-save" className="p-button-text" form="trainingReq-form" type="submit" />
        </>
    );

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error text-align-left">{formik.errors[name]}</small>;
    };

    return (
        <>
            <Toast ref={toast} />

            <Dialog
                visible={props.visible}
                header={translatedMessage('competition.requirements.training')}
                modal
                className="pcn-dialog p-fluid"
                footer={dialogFooter}
                onHide={hideDialog}
            >
                <form id="trainingReq-form" onSubmit={formik.handleSubmit}>
                    {/* <div className="field-checkbox text-left mb-5">
                        <Checkbox inputId="trainingRequired" name="trainingRequired" checked={formik.values?.trainingRequired}
                            onChange={formik.handleChange} />
                        <label htmlFor="trainingRequired">{translatedMessage("competition.requirements.training.required")}</label>
                    </div> */}

                    <div className="field p-inputgroup">
                        <span className="p-float-label">
                            <InputTextarea type="text" id="training" name="training" value={formik.values?.training}
                                onChange={formik.handleChange} className={classNames({ 'p-invalid': isFormFieldValid('training') })}
                                rows={5} cols={30} autoResize
                                maxLength={10000}
                                tooltip={translatedMessage("field.character.maxLength", "10.000")}
                                tooltipOptions={{ position: 'top' }} />
                            <label htmlFor="training" className={classNames({ 'p-error': isFormFieldValid('training') })}>
                                {translatedMessage("competition.requirements.training.info")} *
                            </label>
                        </span>
                    </div>
                    {getFormErrorMessage('training')}


                </form>
            </Dialog>
        </>
    );
};

export default CompetitionTrainingReqEditDialog;
